const styles = {
  root: {
    overflowX: 'auto',
  },
};

export default styles;
